<template>
  <div style="position: relative; background: #fff; overflow: hidden; padding-bottom: 40px">
    <div style="height: 30px; position: relative; margin-bottom: 35px">
      <el-button :type="!editEnable ? 'info' : 'primary'" size="mini"
        style="float: right; margin-right: 45px; margin-top: 25px" @click="editInfo" :disabled="!editEnable"
        icon="el-icon-edit">{{ EditCancel }}</el-button>
      <el-button type="success" size="mini" style="float: right; margin-right: 10px; margin-top: 25px"
        @click="submitForm" :disabled="noEdit" v-if="edit">{{ $t("message.button.save") }}</el-button>
    </div>

    <!-- <div v-show="!edit">
      <div v-for="(item, index) in pageInfo" :key="index">
        <PageShow :page="item" :pageIndex="index" :key="timeRefusr" :reset="resetNum">
        </PageShow>
      </div>
    </div> -->

    <div v-show="!edit">
      <div v-for="(item, index) in pageInfo" :key="index">
        <NewPageShow :page="item" :pageIndex="index" :key="timeRefusr" :reset="resetNum">
        </NewPageShow>
      </div>
    </div>

    <el-form size="mini" ref="form" label-width="280px" v-if="edit">
      <div v-for="(item, index) in pageInfo" :key="index">
        <PageEdit :page="item" :pageIndex="index" :editNum="editNum" :change.sync="item.value" @hasChanged="editChange"
          @MFValue="getMF" :key="timeRefusr" :checkReq.sync="item.req" fromType="redline"
          :itemSubClassId="itemInfo.subClassId">
        </PageEdit>
      </div>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import PageShow from "../../common/page/pageShow.vue";
import NewPageShow from "../../common/page/newPageShow.vue";
// import PageEdit from './page/pageEdit.vue'
export default {
  data() {
    return {
      EditCancel: this.$t("message.button.edit"),
      resetNum: 0,
      timeRefusr: new Date().getTime(),

      pageInfo: [],
      edit: false,
      isClearable: true,
      editNum: 0,
      editEnable: false,
      noEdit: true,
      manufacturerId: "",

      getUrl: {},
      reqList: {},

      input_width: {
        width: "76%",
      },
      mId: false,

      objectId: {},
      changeId: {},
    };
  },
  components: {
    PageShow,
    PageEdit: () => import("../../common/page/pageEdit.vue"),
    NewPageShow,
  },
  mounted() { },
  methods: {
    closeInfo() {
      this.edit = false;
      this.noEdit = true;
      this.reset();
    },
    editChange() {
      this.noEdit = false;
    },

    reset() {
      this.resetNum++;
    },

    getMF(e) {
      this.manufacturerId = e;
      this.mId = true;
    },
    // submitForm(e) {
    //   console.log(this.manufacturerId);},
    submitForm() {
      // console.log(this.manufacturerId);

      const req = this.pageInfo.map(i => i.req);
      console.log(this.pageInfo);
      console.log(req);
      for (const key in req) {
        if (!req[key] && req[key] != undefined) {
          this.$message.error(this.$t('message.warning.required'))
          return
        }
      }

      let m = this.pageInfo.map((i) => i.value);

      // this.objectId.version = this.$store.state.change_info.changeId;
      if (this.mid) {
        Object.assign(m[0], { manufacturerId: this.manufacturerId });
      }

      const itemId = {
        id: this.itemInfo.id,
        classId: this.itemInfo.classId,
        subClassId: this.itemInfo.subClassId,
      };

      axios
        .post(this.getUrl.saveTable, {
          pageOne: m[0] || {},
          pageTwo: m[1] || {},
          pageThree: m[2] || {},
          objectId: itemId,
          changeId: this.changeId,
        })
        .then((res) => {
          //console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getTitleBlockInfo();
            this.$emit("routeClick");
            this.noEdit = true;
            this.editNum = 0;
            this.edit = !this.edit;
          }
        });
    },

    editInfo() {
      console.log(this.editNum);
      this.edit = !this.edit;
      this.editNum++;
      // console.log(this.editNum);
      // console.log(this.editNum%2);
      // if (this.editNum%2) {
      //   console.log("%2=true");
      // } else {
      //   console.log("%2=false");
      //   // this.pageInfo.map((i) => {
      //   //   i.value = null;
      //   // });
      //   // this.noEdit = true;
      // }
      // console.log(this.pageInfo);
      // if(!this.edit){//this.editNum>0 代表点击取消
      //   this.pageInfo = [];
      //   this.getTitleBlockInfo();
      //   // this.editNum = 0;
      // }
    },
    async getTitleBlockInfo() {
      // console.log(11111121212);
      const arr = JSON.parse(sessionStorage.getItem("userContext")).privs;

      console.log(this.itemInfo);
      if (this.itemInfo.id == undefined) { return true };
      const obj_get = {
        //获取change
        id: this.itemInfo.id,
        classId: this.itemInfo.classId,
        subClassId: this.itemInfo.subClassId,
        changeId: this.itemInfo.changeId,
        changeClassId: this.itemInfo.changeClassId,
        changeSubClassId: this.itemInfo.changeSubClassId,
      };

      const pagePriv = arr
        .filter((i) => i.classId == obj_get.subClassId)
        .map((i) => i.type);
      if (pagePriv.includes(3)) {
        // if (this.changeReleased == false) {
        //   this.editEnable = true;
        // };


        this.editEnable = this.changePrivs.add
        // console.log(this.changeReleased);
        // console.log(this.editEnable);
      };
      // let isSupAdmin = this.$store.state.isSuperAdmin;
      // if(isSupAdmin){
      //   this.editEnable = true;
      // };

      this.objectId["id"] = this.$store.state.objectId.id;
      (this.objectId["classId"] = this.$store.state.objectId.classId),
        (this.objectId["subClassId"] = this.$store.state.objectId.subClassId);
      // console.log(9999,this.getUrl);

      this.changeId = {
        id: this.itemInfo.changeId,
        classId: this.itemInfo.changeClassId,
        subClassId: this.itemInfo.changeSubClassId,
      }

      // 给变更-受影响物件 的Redline详细信息页签增加新功能
      // 把之前发三次的loadTable 整合为发一次请求
      // 用newpageshow 替换 pageshow ，只对受影响物件有影响
      if (this.itemInfo.classId.toString().substring(0, 3) == 501) {
        this.getUrl = {
          loadTable: "/pmdm/technology/loadRedLineP1P2P3Table",
          saveTable: "/pmdm/technology/updateTechnologyP1P2P3",
        };
        obj_get.tableId = 5011;
      } else {
        this.getUrl = {
          loadTable: "/pmdm/items/loadRedLineP1P2P3Table",
          saveTable: "/pmdm/items/updateItemP1P2P3",
        };
        obj_get.tableId = 1011;
      }
      const { data: tabOne } = await this.$http.get(this.getUrl.loadTable, {
        params: obj_get,
      });

      // console.log(tabOne);
      // if (this.type == "manufacturerPart") {
      //   // console.log(tabOne);
      //   this.manufacturerId = tabOne.object.table.rows[0].cells[1].id;
      //   console.log(this.manufacturerId);
      // }

      // obj_get.tableId = 2;
      // const { data: tabTwo } = await this.$http.get(this.getUrl.loadTable, {
      //   params: obj_get,
      // });
      // obj_get.tableId = 3;
      // const { data: tabThree } = await this.$http.get(this.getUrl.loadTable, {
      //   params: obj_get,
      // });

      // this.pageInfo = [
      //   { column: tabOne.object.table.columnInfo, val: tabOne.object.table.rows[0] },
      //   { column: tabTwo.object.table.columnInfo, val: tabTwo.object.table.rows[0] },
      //   { column: tabThree.object.table.columnInfo, val: tabThree.object.table.rows[0] },
      // ];

      this.pageInfo = [
        { column: tabOne.object.p1Table.columnInfo, val: tabOne.object.p1Table.rows[0] },
        { column: tabOne.object.p2Table.columnInfo, val: tabOne.object.p2Table.rows[0] },
        { column: tabOne.object.p3Table.columnInfo, val: tabOne.object.p3Table.rows[0] },
      ];

      // console.log(this.pageInfo[1].val.cells);
      this.$store.commit("setItemTitleBlockImg", { isItem: false, changeInfo: this.itemInfo });
    },
    changeType(res) {
      this.$forceUpdate();
    },
  },
  created() {
    this.getTitleBlockInfo();
    console.log(this.itemInfo);
    console.log(this.changeReleased);
    console.log(this.changePrivs);
    this.editEnable = this.changePrivs.add
  },
  computed: {},
  // props: ['changeValue','type'],
  props: {
    changeValue: {},
    type: {
      //进度条类型
      type: String,
      // default: 'line',
      validator: (val) =>
        [
          "item",
          "change",
          "manufacturer",
          "manufacturerPart",
          "user",
          "userGroup",
        ].indexOf(val) > -1,
    },
    itemInfo: {},
    changeReleased: "",
    changePrivs: { type: Object }
  },
  watch: {
    changeValue: function (value) {
      // this.get_change_info = value;
      // console.log(value);
      this.getTitleBlockInfo();
    },
    edit(e) {
      if (e) {
        this.EditCancel = this.$t("message.button.cancel");
      } else {
        this.EditCancel = this.$t("message.button.edit");
      }
    },
    type: function (e) {
      console.log("tttttttt", e);
      this.pageType = e;
    },
    itemInfo: function (e) {
      this.getTitleBlockInfo();
      console.log("itemInfo", e);
    },
  },
};
</script>

<style>
ol,
ul {
  list-style: none;
}

.moneyUi .el-input-group__append {
  width: 30% !important;
}
</style>

<style scoped>
.heading-edit {
  width: 100% !important;
  margin: 0 0 18px 40px;
}

.view-page2 {
  position: relative;
  overflow: hidden;
  list-style: none;
  width: 100%;
  margin-top: 20px;
  padding-left: 40px;
  padding-top: 20px;
  padding-bottom: 20px;
  background: #f4f7f9;
  background-image: url(~@/assets/titleBlock/page2.png);
  background-repeat: no-repeat;
  background-position: bottom right;
}

.view-page3 {
  position: relative;
  overflow: hidden;
  list-style: none;
  width: 100%;
  margin-top: 20px;
  padding-left: 40px;
  padding-bottom: 20px;
}

.heading {
  width: 100%;
  float: left;
  margin: 0px 0 18px 0;
}

.heading p {
  font-size: 18px;
  margin: 0;
}

.title-heading {
  width: 100%;
  float: left;
  margin: 0 0 18px -20px;
}

.title-heading p {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.page1 {
  width: 50%;
  overflow: hidden;
}

.page2 {
  width: 50%;
  float: left;
}

.page3 {
  width: 50%;
  float: left;
}

ul {
  margin: 0;
}

.line01 {
  border-bottom: 1px solid #cecece;
  padding: 10px 0;
}

div {
  font-size: 12px;
}

.table-list {
  height: 20px;
  overflow: hidden;
  margin-top: 4px;
}

.table-list li {
  overflow: hidden;
}

.table-list .list-key {
  display: inline-block;
  width: 42%;
  text-align: right;
  font-size: 14px;
}

.table-list .list-val {
  display: inline-block;
  width: 52%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
  font-size: 14px;
  position: relative;
  top: 3px;
}

.table-list .list-key-1 {
  display: inline-block;
  width: 18.5%;
  text-align: right;
  font-size: 14px;
  color: #000;
}
</style>
